import axios from 'axios'
import WS from '@/api/Websocket'
import Config from '@/project'

const http = axios.create({
  crossDomain: true,
  withCredentials: true,
  timeout: 0
})
const safeHttp = axios.create({
  crossDomain: true,
  timeout: 0
})

const localTimezone = JSON.stringify(new Date())
http.defaults.headers.common['Local-Timezone'] = localTimezone

let defaultQueryParams = {}

const handleRequest = async (req) => {
  try {
    const result = await req()
    return { data: result.data, headers: result.headers, error: false }
  } catch (e) {
    console.error(e)
    if (e.response && e.response.data) {
      return { data: e.response.data, headers: e.response.headers, error: true }
    } else {
      return { data: { errorCode: 'Error' }, error: true }
    }
  }
}
const currentUrlHeader = () => ({ 'Origin-Fullpath': window.location.href })

const wrappedHttp = (http) => ({
  http,
  get (path, data, options) {
    return handleRequest(() => {
      return http.get(path, { headers: currentUrlHeader(), params: { ...defaultQueryParams, ...data }, ...options })
    })
  },
  post (path, data, options) {
    return handleRequest(() => {
      return http.post(path, data, { headers: currentUrlHeader(), ...options })
    })
  },
  put (path, data, options) {
    return handleRequest(() => {
      return http.put(path, data, { headers: currentUrlHeader(), ...options })
    })
  },
  delete (path, data, options) {
    return handleRequest(() => {
      return http.delete(path, { params: data }, { headers: currentUrlHeader(), ...options })
    })
  },
  deleteBody (path, data, options) {
    return handleRequest(() => {
      return http.delete(path, { data }, { headers: currentUrlHeader(), ...options })
    })
  }
})

export default {
  wrapped: wrappedHttp(http),
  domain: Config.domains.baseUrl,
  baseUrl: Config.domains.api,
  websocketUrl: Config.domains.websocket,

  cancelToken () {
    return axios.CancelToken.source()
  },

  setHeader (key, value) {
    http.defaults.headers.common[key] = value
  },

  removeHeader (key) {
    delete http.defaults.headers.common[key]
  },

  setDefaultQueryString(params) {
    defaultQueryParams = { ...defaultQueryParams, ...params }
  },

  intercepResponse (success, error) {
    if (typeof success !== 'function') {
      success = (res) => res
    }
    http.interceptors.response.use(success, error)
  },

  get (path, data, options) {
    return this.wrapped.get(`${this.baseUrl}${path}`, data, options)
  },

  post (path, data, options) {
    return this.wrapped.post(`${this.baseUrl}${path}`, data, options)
  },

  put (path, data, options) {
    return this.wrapped.put(`${this.baseUrl}${path}`, data, options)
  },

  delete (path, data, options) {
    return this.wrapped.delete(`${this.baseUrl}${path}`, data, options)
  },

  deleteBody (path, data, options) {
    return this.wrapped.deleteBody(`${this.baseUrl}${path}`, data, options)
  },

  raw () {
    return this.wrapped
  },

  defaultRaw () {
    return wrappedHttp(safeHttp)
  },

  websocket () {
    if (!this.ws) {
      this.ws = new WS(this.websocketUrl)
    }
    return this.ws
  },

  mockCall () {
    return {error: true}
  }
}
